<span *ngIf="model | hasErrors: validate" class="text-danger">
  <span [innerText]="error"></span>
</span>
